import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IDatatableOutputDTO,
  IDatatableParams,
} from 'src/app/shared/datatables/datatables';
import { HttpParamsMapper } from 'src/app/shared/mappers/http-params.mapper';

export type IndicationsReportRow = {
  id: number;
  status: string;
  documentCount: number;
  patient: {
    id: number;
    name: string;
    cpf: string;
    mobile: string;
  };
  user: {
    id: number;
    email: string;
    account: {
      id: number;
      name: string;
      email: string;
    };
  };
};

export type IndicationScheduleDocument = {
  id: number;
  url: string;
  createdAt: number;
  isActive: boolean;
};

export type IndicationScheduleOption = {
  id: number;
  doctorName: string;
  date: string;
  status: string;
  documents: IndicationScheduleDocument[];
};

@Injectable({ providedIn: 'root' })
export class AdministrativeIndicationsReportService {
  url = `${environment.api_v2}/v2/administrative/indications`;

  constructor(private readonly http: HttpClient) {}

  search({
    filter,
    page,
    perPage,
  }: IDatatableParams): Observable<IDatatableOutputDTO<any>> {
    const params = HttpParamsMapper.toHttpParams({
      filter: JSON.stringify(filter ?? {}),
      page,
      perPage,
    });
    return this.http.get<IDatatableOutputDTO<any>>(this.url, { params });
  }

  exportCsv(filter: any): Observable<HttpResponse<Blob>> {
    // A rota base (this.url) é a listagem paginada e exige page/perPage; o CSV é a rota dedicada /export.
    return this.http.get<Blob>(`${this.url}/export`, {
      headers: { Accept: 'text/csv' },
      params: { filter: JSON.stringify(filter) },
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  listSchedules(indicationId: number): Observable<IndicationScheduleOption[]> {
    return this.http.get<IndicationScheduleOption[]>(
      `${this.url}/${indicationId}/schedules`
    );
  }

  attachReport(
    indicationId: number,
    body: { scheduleId: number; url: string; issuedAt: string; observation?: string }
  ): Observable<void> {
    return this.http.post<void>(
      `${this.url}/${indicationId}/attach-report`,
      body
    );
  }

  setDocumentActiveStatus(
    indicationId: number,
    documentId: number,
    isActive: boolean
  ): Observable<void> {
    return this.http.patch<void>(
      `${this.url}/${indicationId}/documents/${documentId}/active-status`,
      { isActive }
    );
  }

  searchFinancial({
    filter,
    page,
    perPage,
  }: IDatatableParams): Observable<IDatatableOutputDTO<any>> {
    const params = HttpParamsMapper.toHttpParams({
      filter: JSON.stringify(filter ?? {}),
      page,
      perPage,
    });
    return this.http.get<IDatatableOutputDTO<any>>(`${this.url}/financial`, {
      params,
    });
  }
}
